<template>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="16" cy="16" r="2.5" stroke="currentColor"/>
        <circle cx="6" cy="11" r="2.5" stroke="currentColor"/>
        <circle cx="16" cy="6" r="2.5" stroke="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3254 7.7782L8.42188 9.22998C8.61789 9.49776 8.77059 9.79925 8.86962 10.1241L11.7733 8.67231C11.5956 8.39193 11.4451 8.09266 11.3254 7.7782ZM8.42188 12.7703C8.61789 12.5026 8.77059 12.2011 8.86962 11.8762L13.5775 14.2301C13.3815 14.4979 13.2288 14.7994 13.1298 15.1243L8.42188 12.7703Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGShare',
};
</script>

<style scoped lang="scss">

</style>
